module.exports = __webpack_public_path__ + "za.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/za.svg
// module id = 896
// module chunks = 0